export default __webpack_public_path__ + "static/media/second.df2fd805.png";